import React, { useCallback, useEffect, useState } from 'react';
import LeftChevron from '../../assets/images/left-chevron.svg';
import { CompletedPopup, Image, ProgressBar, Stepper } from '../../components/componentIndex';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PersonalInformationService from '../../services/API/personalInformationService';
import CommonService from '../../services/API/commonService';
import { useAuthenticationContext } from 'services/slices/AuthenticationSlicer';
import { toast } from 'react-toastify';
import { Button } from 'common/commonIndex';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import useDebounce from 'hooks/useDebounce';
// import './../../assets/styles/components/questionnaire.scss';
// const steps = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

const Questionnaire = () => {
  let findStep = parseInt(window.location.search.slice(1))
  // let findStep;
  const [currentStep, setCurrentStep] = useState(0);
  const [response, setResponse] = useState({});
  const [listOfQuestions, setListOfQuestions] = useState([]);
  const [listOfAnswer, setListOfAnswer] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [denialScreen, setDenialScreen] = useState(false);
  const [isCallApi, setIsCallApi] = useState(false);
  const [states, setStates] = useState([]);
  const [surgeryCenterId, setSurgeryCenterId] = useState(null);
  const [searchParams] = useSearchParams();
  const [formValues, setFormValues] = useState({
    heightFT: '',
    heightIN: '',
    weight: '',
    colonoscopy: '',
    lastColonoscopy: '',
    ageDiagnosis: '',
    diagnosedWith: [],
    medications: '',
    allergiesMedications: '',
    driverLicensePhotoID: '',
    frontInsuranceCard: '',
    backInsuranceCard: '',
    bowelPrepMailed: '',
    mailingAddress: '',
    insuranceID: '',
    insuranceGroup: '',
    insuranceBin: '',
    insurancePCN: '',
  });
  const { state: data } = useAuthenticationContext();
  let isCall = false;
  const navigate = useNavigate();
  const location = useLocation(); // Current location object

  let deniedObj = {
    status: 'Denied',
    mainTitle: 'Call to schedule',
    title: 'Schedule an appointment',
    message: 'Based on your answers, you will need an office visit before scheduling your colonoscopy.',
    buttonName: 'Call us'
  }
  let completedObj = {
    status: 'Completed',
    title: 'Pre-screening Questionnaire',
    message: 'Before we can confirm your appointment, we need to determine your eligibility. Please complete the following questionnaire. We will hold your appointment for 24 hours.',
    buttonName: 'Start the questionnaire'
  }


  //Handle next step
  const handleNext = (step) => {
    if (step) {
      if (step < listOfQuestions?.length) {
        // setStepAndRedirect(step);
        if (step > 1) {
          handleSubmitFrom(step);
        } else {
          setStepAndRedirect(step);
        }
      } else {
        handleSubmitFrom();
      }
    } else {
      if (currentStep < listOfQuestions?.length - 1) {
        setStepAndRedirect(currentStep + 1);
      }
    }
  };
  const getLocalStorageData = () => {
    const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
    return findlocalStorageData;
  }
  const setLocalStorageData = (data) => {
    if (data?.length > 0) {
      localStorage.setItem('listOfAnswer', JSON.stringify(data));
    }
  }
  //Handle previous step
  const handlePrev = (step) => {
    // if (step > 0) {
    //   setStepAndRedirect(step);
    // } else {
      if (currentStep > 0) {
        let findPrevIndex =  listOfQuestions.findIndex(x => x.skippedNestedQuestionID === listOfQuestions[currentStep].id);
       
        if(findPrevIndex > 0 && listOfAnswer[findPrevIndex]?.answer === 'No' || listOfAnswer[findPrevIndex]?.answer === 'no'){
          setStepAndRedirect(findPrevIndex);
        }else{
          setStepAndRedirect(currentStep - 1);
        }
      }
    // }
  };
  const updateQueryParam = (key, value) => {
    // Parse the current query parameters
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(key)) {
      // If the key exists, update its value
      searchParams.set(key, value);
    } else {
      // If the key doesn't exist, add the key-value pair
      searchParams.append(key, value);
    }
    if (searchParams.has('appointmentId')) {
      const appointmentId = searchParams.get('appointmentId')
      searchParams.set('appointmentId', appointmentId === '0' ? '46' : appointmentId);
    } else {
      searchParams.append('appointmentId', '46');
    }
    console.log('listOfAnswer', listOfAnswer);
    navigate('/questionnaire?' + searchParams.toString());
  };
  //Set Step & Redirect
  const setStepAndRedirect = (step) => {
    setCurrentStep(step);
    updateQueryParam('step', step);
  }

  const getQuestions = async () => {
    if (isCall) {
      return;
    }
    isCall = true;
    try {
      const accessToken = data?.userData?.result?.token;
      const doctorId = searchParams.get('fkUserId'); //'c5adc14b-16ff-4952-9d91-0277fa779aa6'; //
      const visitId = parseInt(searchParams.get('appointmentId'));
      setIsLoading(true);
      const response = await PersonalInformationService.getQuestions(doctorId, visitId, accessToken);
      if (response?.statusCode === 200) {
        const responseResult = response?.result;
        setResponse(responseResult);
        const firstObj = {
          "id": null,
          "fkSurgeryCenterId": 694,
          "question": null,
          "questionType": 0,
          "displayOrder": 0,
          "nextQuestionID": null,
          "skippedNestedQuestionID": null,
          "listOfAnswers": null,
          "autoDeny": 0,
          "questionerIndex": 0,
          "nestedQuestions": null
        };

        const lastObj = {
          "id": null,
          "fkSurgeryCenterId": 694,
          "question": null,
          "questionType": 20,
          "displayOrder": 20,
          "nextQuestionID": null,
          "skippedNestedQuestionID": null,
          "listOfAnswers": null,
          "autoDeny": 0,
          "questionerIndex": listOfQuestions.length + 1,
          "nestedQuestions": null
        };
        if (responseResult?.listOfQuestions?.length > 0) {
          const updatedListOfQuestions = [firstObj, ...responseResult?.listOfQuestions, lastObj];

          setListOfQuestions(updatedListOfQuestions);
          let transformedQuestions = updatedListOfQuestions?.map((item) => ({
            fkQuestionId: item?.id, // Map the `id` to `fkQuestionId`
            answer: item?.listOfAnswers || item?.question?.includes('height') ? [] : null, // Map answers or default to "string"
            fkAnswerIds: item?.listOfAnswers || item?.question?.includes('height') ? [] : null, // Map answer IDs or default to "string"
            questionType: item?.questionType || 0 // Map `questionType` or default to 0
          }));

          let avc = getQuestionAnswer(responseResult?.listOfAnswers, transformedQuestions);
          let findLocalStorageData = getLocalStorageData();
          if (findLocalStorageData?.length === 0 || findLocalStorageData === null) {
            setLocalStorageData(avc);
          } else {
            if (findLocalStorageData?.length > 0) {
              avc = findLocalStorageData;
            }
          }
          setListOfAnswer(avc);
          if (response?.result?.questionStartIndex === 1) {
            setStepAndRedirect(0);
          } else {
            setStepAndRedirect(response?.result?.questionStartIndex);
          }

        }
      } else {
        toast.error(response?.message);
      }
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      console.error("Login failed: ", error);
    }
  };
  const getQuestionAnswer = (answerList, questionList) => {
    questionList?.forEach(item => {
      let findAnswer = answerList?.find(x => x.questionType === item?.questionType && x.fkQuestionId === item.fkQuestionId);
      switch (item?.questionType) {
        case 1:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 2:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 3:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 4:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 5:
          item.answer = findAnswer?.answer?.split("||").map(x => x.trim());
          item.fkAnswerIds = findAnswer?.fkAnswerIds?.split("||").map(x => x.trim());
          break;

        case 6:
          item.answer = findAnswer?.answer?.split("||").map(x => x.trim());
          item.fkAnswerIds = findAnswer?.fkAnswerIds?.split("||").map(x => x.trim());
          break;

        case 7:
          item.answer = findAnswer?.answer && findAnswer?.answer !== '' ? findAnswer?.answer?.match(/\d+/g).map(Number) : null;
          item.fkAnswerIds = findAnswer?.fkAnswerIds && findAnswer?.fkAnswerIds !== '' ? findAnswer?.fkAnswerIds?.match(/\d+/g).map(Number) : null;
          break;

        case 8:
          item.answer = findAnswer?.answer && findAnswer?.answer !== '' ? parseInt(findAnswer?.answer?.match(/\d+/)[0], 10) : null;
          item.fkAnswerIds = findAnswer?.fkAnswerIds && findAnswer?.fkAnswerIds !== '' ? parseInt(findAnswer?.fkAnswerIds?.match(/\d+/)[0], 10) : null;
          break;

        case 9:
          item.answer = findAnswer?.answer?.split("||").map(x => x.trim());
          item.fkAnswerIds = findAnswer?.fkAnswerIds?.split("||").map(x => x.trim());
          break;

        case 10:
          item.answer = findAnswer?.answer?.split("||").map(x => x.trim());
          item.fkAnswerIds = findAnswer?.fkAnswerIds?.split("||").map(x => x.trim());
          break;

        case 11:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 12:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 13:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 14:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 15:
          const findAddress = answerList?.filter(x => x.questionType === 152);
          item.answer = findAddress;
          item.fkAnswerIds = findAddress;
          break;

        case 16:
          const findInsurance = answerList?.filter(x => x.questionType === 142);
          item.answer = findInsurance;
          item.fkAnswerIds = findInsurance;
          break;

        case 17:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 18:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        case 19:
          item.answer = findAnswer?.answer;
          item.fkAnswerIds = findAnswer?.fkAnswerIds;
          break;

        default:

          console.log(`Unknown question type. Question ID: ${item.fkQuestionId}, Answer: ${item.answer}`);
      }
    });
    return questionList;

  }
  const debouncedGetQuestions = useDebounce(getQuestions, 300);

  useEffect(() => {
    if (listOfQuestions.length === 0) {
      debouncedGetQuestions();
    }
  }, [listOfQuestions.length === 0])

  const handleSubmitFrom = async (step) => {
    let findData = getLocalStorageData();
    let updatedA;
    const answerList = findData?.length > 0 ? findData : listOfAnswer;
    const findSearchParamsStep = parseInt(searchParams.get('step'));
     
    let findQuestionData = findQuestions(answerList[findSearchParamsStep], updatedA);
    // let findQuestionData = findQuestions(answerList[step - 1], updatedA);
    const fkSurgeryCenterId = listOfQuestions.find(x => x.fkSurgeryCenterId).fkSurgeryCenterId;
    const fkAppointmentId = parseInt(searchParams.get('appointmentId'));
    // handleSetSkipQuestionIndex();
    // let findQuestionData = findResult?.filter(x => x.questionerType !== 15 && x.questionerType !== 16)
    handleSubmitQuestionnaire(fkSurgeryCenterId, fkAppointmentId, findQuestionData, null, step, answerList);
  }

  //   const handleSetSkipQuestionIndex = (value) => {
  //     let sliceArray = questionnairelist?.slice(1, -1);
  //     const currentIndex = parseInt(searchParams.get('step')); // Get the current index
  //     const idKey = value?.toLowerCase() === 'yes' ? 'nextQuestionID' : 'skippedNestedQuestionID';

  //     // Get the target ID based on the condition
  //     const targetID = sliceArray[currentIndex]?.[idKey];

  //     // Find the nested index
  //     const nestedIndex = sliceArray?.findIndex((element) => element.id === targetID);

  //     // Set the nested index and store it in localStorage
  //     // setNestedIndex(nestedIndex);
  //     return nestedIndex;


  // }

  const findQuestions = (questionData, updatedA) => {
    if (!questionData) return questionData;

    const { questionType, answer, fkAnswerIds } = questionData;
    let updatedAnswer = answer;
    let updatedFkAnswerIds = fkAnswerIds;
    switch (questionType) {
      case 7: // Height (Feet and Inches)
        if (Array.isArray(answer) && answer.length > 0) {
          updatedAnswer = `${answer[0]} Ft ${answer[1]} In`;
          updatedFkAnswerIds = `${fkAnswerIds[0]} Ft ${fkAnswerIds[1]} In`;
        } else {
          if (answer) {
            updatedAnswer = `${answer} lbs`;
            updatedFkAnswerIds = `${fkAnswerIds} lbs`;
          } else {
            updatedAnswer = '';
            updatedFkAnswerIds = '';
          }
        }
        break;

      case 8: // Weight (lbs)
        // if (answer) {
        //   updatedAnswer = `${answer} lbs`;
        //   updatedFkAnswerIds = `${fkAnswerIds} lbs`;
        // } else {
        //   updatedAnswer = '';
        //   updatedFkAnswerIds = '';
        // }
        if (Array.isArray(answer) && answer.length > 0) {
          updatedAnswer = `${answer[0]} Ft ${answer[1]} In`;
          updatedFkAnswerIds = `${fkAnswerIds[0]} Ft ${fkAnswerIds[1]} In`;
        } else {
          if (answer) {
            updatedAnswer = `${answer} lbs`;
            updatedFkAnswerIds = `${fkAnswerIds} lbs`;
          } else {
            updatedAnswer = '';
            updatedFkAnswerIds = '';
          }
        }
        break;

      case 1:
        if (answer) {
          updatedAnswer = answer;
          updatedFkAnswerIds = fkAnswerIds;
        } else {
          updatedAnswer = '';
          updatedFkAnswerIds = '';
        }
        break;

      case 6:
      case 5:
      case 9:
      case 10: // Multiple choice answers
        if (Array.isArray(answer) && answer.length > 0) {
          updatedAnswer = answer.join('|| ');
          updatedFkAnswerIds = fkAnswerIds?.join('|| ');
        } else {
          updatedAnswer = '';
          updatedFkAnswerIds = '';
        }
        break;

      case 4: // Null or empty answers
        if (!answer || answer.length === 0) {
          updatedAnswer = '';
          updatedFkAnswerIds = '';
        }
        break;

      case 15:
      case 16: // Special case for main and insurance data
        if (Array.isArray(answer) && answer.length > 0) {
          const extractedData = [questionData]?.flatMap(item =>
            item.answer.map(subItem => ({
              fkQuestionId: subItem.fkQuestionId,
              answer: subItem.answer ? subItem.answer : '',
              fkAnswerIds: subItem.fkAnswerIds ? subItem.fkAnswerIds : '',
              questionType: subItem.questionType,
            }))
          );
          return extractedData;
        }
        break;

      default:
        break;
    }

    // Handle null or undefined answers
    if (updatedAnswer === null || updatedAnswer === undefined) {
      updatedAnswer = '';
      updatedFkAnswerIds = '';
    }

    return {
      ...questionData,
      answer: updatedAnswer,
      fkAnswerIds: updatedFkAnswerIds,
    };
  };


  const handleSubmitQuestionnaire = async (fkSurgeryCenterId, fkAppointmentId, answerData, type, step, answerList) => {
    let questionnaireRequest = {
      "fkSurgerCenterId": fkSurgeryCenterId, //surgeryCenterId
      "fkAppointmentId": fkAppointmentId, //appointmentId
      "listOfAnswer": answerData?.length > 0 ? answerData : [answerData],
    }
    try {
      setIsLoading(true);
      const accessToken = data?.userData?.result?.token;
      const response = await PersonalInformationService.submitQuestionnaire(questionnaireRequest, accessToken);
      if (response?.statusCode === 200) {
          setStepAndRedirect(step);
        // handleResponse(response, step, answerList);
      } else {
        toast.error(response?.message);
      }
      setIsLoading(false);
      return response;
    } catch (error) {
      console.error("Login failed: ", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleResponse = (response, step, answerList) => {
    let findIndex = null;

    // Retrieve skippedQuestionIndex from localStorage
    const skippedQuestionIndex = localStorage.getItem('skippedQuestionIndex');
    if (skippedQuestionIndex && skippedQuestionIndex !== 'undefined') {
      findIndex = JSON.parse(skippedQuestionIndex);
    }
    
    let findQuestionIndex = listOfQuestions.find(x => x.questionerIndex === step - 1);
    // If findIndex is -1, navigate directly to the screen
    if (findIndex === -1 || findQuestionIndex?.nextQuestionID === null) {
      handleRouteToScreen(response, step);
      return;
    } else if (findIndex) {
      // Handle skipped questions scenario
      setDenialScreen(false);
      setSurgeryCenterId(null);
      step = findIndex; // Assuming `step` is declared and managed properly
    }

    // Manage the step logic and redirect
    if (findIndex !== -1) {
      if (answerList?.length === step) {
        handleLandingPage();
      } else {
        setStepAndRedirect(step);
      }
    }

    // Cleanup localStorage
    // localStorage.removeItem('skippedQuestionIndex');
  };

  const handleRouteToScreen = (response, step) => {
    const isDenied = response?.result?.isDenied;
    const surgeryCenterNumber = response?.result?.surgeryCenterNumber;

    if (isDenied) {
      setSurgeryCenterId(surgeryCenterNumber);
      setDenialScreen(true);
    } else {
      setSurgeryCenterId(null);
      setDenialScreen(false);
      setStepAndRedirect(listOfQuestions?.length - 1);
      step = listOfQuestions?.length - 1; // Navigate to the last question
      return;
    }


    // Cleanup localStorage
    // localStorage.removeItem('skippedQuestionIndex');

  };


  // const handleResponse = () => {
  //   let findIndex;
  //   const skippedQuestionIndex = localStorage.getItem('skippedQuestionIndex');
  //   if (skippedQuestionIndex && skippedQuestionIndex !== 'undefined') {
  //     findIndex = JSON.parse(skippedQuestionIndex);
  //   } else {
  //     findIndex = null; // or assign a default value if needed
  //   }
  //   if (findIndex === -1) {
  //     handleRouteToScreen(response);
  //   } else if (findIndex) {
  //     setDenialScreen(false);
  //     setSurgeryCenterId(null);
  //     step = findIndex;
  //   } else {
  //     step = step;
  //   }
  //   if (findIndex !== -1) {
  //     if (answerList?.length === step) {
  //       handleLandingPage();
  //     } else {
  //       setStepAndRedirect(step);
  //     }
  //   }

  //   localStorage.removeItem('skippedQuestionIndex');
  // }

  // const handleRouteToScreen = (response) => {
  //   if (response?.result?.isDenied) {
  //     setSurgeryCenterId(response?.result?.surgeryCenterNumber);
  //     setDenialScreen(true);
  //     localStorage.removeItem('skippedQuestionIndex');
  //   } else {
  //     setSurgeryCenterId(null);
  //     setDenialScreen(false);
  //     step = listOfQuestions.length - 1;
  //     localStorage.removeItem('skippedQuestionIndex');
  //   }
  // };

  const handleLandingPage = () => {
    navigate('/visits');
  }
  const handleBack = () => {
    localStorage.removeItem('listOfAnswer');
    navigate('/landing');
  }

  const closeFullScreen = () => {
    setDenialScreen(false);
    if (surgeryCenterId) {
      handleBack();
    }
    if (!surgeryCenterId) {
      const userId = searchParams.get('fkUserId');
      const fkVisitId = parseInt(searchParams.get('appointmentId'));
      const url = `/questionnaire?fkUserId=${userId}&appointmentId=${fkVisitId}&step=0`;
      navigate(url);
    }
  }

  return (
    <div>
      <div className="stepper stepper-content" >
        {listOfQuestions && listOfQuestions?.length > 0 ? (
          <>
            {currentStep !== listOfQuestions?.length - 1 && (
              <div className='d-flex align-items-center progress-bar-margin'>
                <div onClick={handlePrev} className='px-3 cursor-pointer'>
                  <img src={LeftChevron} alt="Left Chevron" />
                </div>
                <ProgressBar currentStep={currentStep} steps={listOfQuestions} />
                <div onClick={handleBack} className='px-3 cursor-pointer'>
                  <Image imgUrl={CloseIcon} altText={"Left Chevron"} className={'cancle-questionnaire'} />
                </div>
              </div>
            )}


            <div className="steps">
              {listOfQuestions?.map((item, index) => (
                <>
                  {index === currentStep && (
                    <div key={index}>
                      <Stepper handleNext={handleNext} formValues={listOfAnswer[index]} listOfQuestion={item} listOfAnswer={listOfAnswer} questionnairelist={listOfQuestions} />
                    </div>
                  )}
                </>
              ))}
            </div>
          </>
        ) : (
          <>
            {isLoading ? (
              <div className="loader-content">
                <div className="loader"></div>
              </div>
            ) : (
              <div className='d-flex justify-content-center align-items-center h-100'>
                <div className=''>
                  <p className='nothing-to-show'>Nothing to show</p>
                  <Button
                    btnClass={'btn-primary question-btn'}
                    btnType={'button'}
                    btnName={'Go Back'}
                    onClick={handleBack}
                    isDisabled={true}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {denialScreen && (
        <CompletedPopup selectedVisit={deniedObj} closeFullScreens={closeFullScreen} />
      )}
    </div>
  );
};

export default Questionnaire;

